const integer = (value) => Number.isSafeInteger(value) && value >= 0;
const id = (value) => integer(value) && value > 0;
export function canUseOther(universe) {
  return (
    universe?.canAttendWithOther === true &&
    universe.radiusKm === 500 &&
    universe.state === 'COMPLETE' &&
    universe.pendingCount === 0 &&
    integer(universe.eligibleCount) &&
    universe.refusedCount === universe.eligibleCount
  );
}

export function otherCandidates(data, context) {
  const seen = new Set();
  if (
    !data ||
    data.loadId !== context.item.loadId ||
    data.loadKind !== context.item.type ||
    !canUseOther(data.operationalUniverse) ||
    !integer(data.totalCount) ||
    !Array.isArray(data.data) ||
    data.data.length !== Math.min(data.totalCount, 25) ||
    data.data.some((row) => {
      if (
        !row ||
        !id(row.vehicleId) ||
        seen.has(row.vehicleId) ||
        typeof row.plate !== 'string' ||
        !row.plate.trim() ||
        (row.driver !== null &&
          (!id(row.driver?.id) ||
            (row.driver.name !== null && typeof row.driver.name !== 'string'))) ||
        !Array.isArray(row.wagons) ||
        !row.wagons.every((w) => id(w?.id) && typeof w.plate === 'string') ||
        !Number.isFinite(row.distanceMeters) ||
        row.distanceMeters <= 500000
      )
        return true;
      seen.add(row.vehicleId);
      return false;
    })
  )
    throw new Error('Resposta inválida de outros veículos. Atualize a consulta.');
  return data;
}
